import Players from '@/services/player/Players';
import PresetCommunityCards from '@/services/PresetCommunityCards';
import PresetHoleCards from '@/services/PresetHoleCards';
import shareUrlService from '@/services/share-url-service';
import storeService from '@/store/service';
import utilities from '@/services/utilities/utilities';

let state = {
  totalNumberOfSimulations: null,
  presetHoleCards: new PresetHoleCards(),
  presetCommunityCards: new PresetCommunityCards(),
  players: new Players(),
};

let getters = {
  percentageOfTimeEveryoneMissesTheBoard: function (state) {
    return function (street) {
      return storeService.getPercentageOfTimeEveryoneMissesTheBoard(state, street);
    };
  },
  percentageOfTimeExactlyOnePlayerHitsTheBoard: function (state) {
    return function (street) {
      return storeService.getPercentageOfTimeExactlyOnePlayerHitsTheBoard(state, street);
    };
  },
  percentageOfTimeTwoOrMorePlayersHitTheBoard: function (state) {
    return function (street) {
      return storeService.getPercentageOfTimeTwoOrMorePlayersHitTheBoard(state, street);
    };
  },
  cumulativeHitPercentages: function (state) {
    return storeService.getCumulativeHitPercentages(state);
  },
};

let mutations = {
  setState: function (state, stateFromServer) {
    shareUrlService.setHitCalculatorStoreState(stateFromServer, state);
  },

  // player range
  selectGeneralHand: function (state, payload) {
    storeService.selectGeneralHand(state, payload);
  },
  deselectGeneralHand: function (state, payload) {
    storeService.deselectGeneralHand(state, payload);
  },
  manuallySelectGeneralHand: function (state, payload) {
    storeService.manuallySelectGeneralHand(state, payload);
  },
  manuallyDeselectGeneralHand: function (state, payload) {
    storeService.manuallyDeselectGeneralHand(state, payload);
  },
  selectGeneralHands: function (state, payload) {
    storeService.selectGeneralHands(state, payload);
  },
  deselectGeneralHands: function (state, payload) {
    storeService.deselectGeneralHands(state, payload);
  },
  deselectAllGeneralHands: function (state, payload) {
    storeService.deselectAllGeneralHands(state, payload);
  },
  selectSpecificHand: function (state, payload) {
    storeService.selectSpecificHand(state, payload);
  },
  deselectSpecificHand: function (state, payload) {
    storeService.deselectSpecificHand(state, payload);
  },
  manuallySelectSpecificHand: function (state, payload) {
    storeService.manuallySelectSpecificHand(state, payload);
  },
  manuallyDeselectSpecificHand: function (state, payload) {
    storeService.manuallyDeselectSpecificHand(state, payload);
  },
  manuallyDeselectAllGeneralHands: function (state, payload) {
    storeService.manuallyDeselectAllGeneralHands(state, payload);
  },
  selectSpecificHands: function (state, payload) {
    storeService.selectSpecificHands(state, payload);
  },
  setSpecificHandAsManuallySet: function (state, payload) {
    storeService.setSpecificHandAsManuallySet(state, payload);
  },
  setSpecificHandAsNotManuallySet: function (state, payload) {
    storeService.setSpecificHandAsNotManuallySet(state, payload);
  },
  applyExactWeightToGeneralHand: function (state, payload) {
    storeService.applyExactWeightToGeneralHand(state, payload);
  },
  applyExactWeightToGeneralHands: function (state, payload) {
    storeService.applyExactWeightToGeneralHands(state, payload);
  },
  setWeightOfSpecificHand: function (state, payload) {
    storeService.setWeightOfSpecificHand(state, payload);
  },
  manuallyApplyExactWeightToGeneralHand: function (state, payload) {
    storeService.manuallyApplyExactWeightToGeneralHand(state, payload);
  },
  manuallySetWeightOfSpecificHand: function (state, payload) {
    storeService.manuallySetWeightOfSpecificHand(state, payload);
  },
  clearManuallyAddedHands: function (state, payload) {
    storeService.clearManuallyAddedHands(state, payload);
  },
  clearManuallyRemovedHands: function (state, payload) {
    storeService.clearManuallyRemovedHands(state, payload);
  },
  setRangesAccordingToFilters: function (state, playerIndex) {
    storeService.setRangesAccordingToFilters(state, playerIndex);
  },

  // player other
  setWeightToApplyToAddedHands: function (state, payload) {
    storeService.setWeightToApplyToAddedHands(state, payload);
  },
  addComboToCombosToAdd: function (state, payload) {
    storeService.addComboToCombosToAdd(state, payload);
  },
  removeComboFromCombosToAdd: function (state, payload) {
    storeService.removeComboFromCombosToAdd(state, payload);
  },
  highlightGeneralHandsThatMatchFiveCardHand: function (state, payload) {
    storeService.highlightGeneralHandsThatMatchFiveCardHand(state, payload);
  },
  removeFiveCardHandHighlights: function (state, payload) {
    storeService.removeFiveCardHandHighlights(state, payload);
  },

  // controls
  setPresetHoleCard: function (state, payload) {
    storeService.setPresetHoleCard(state, payload);
  },
  removePresetHoleCard: function (state, position) {
    storeService.removePresetHoleCard(state, position);
  },
  setIndividualPresetCommunityCard: function (state, payload) {
    storeService.setIndividualPresetCommunityCard(state, payload);
  },
  setBoard: function (state, boardCards) {
    storeService.setBoard(state, boardCards);
  },
  removePresetCommunityCard: function (state, position) {
    storeService.removePresetCommunityCard(state, position);
  },
  addPlayer: function (state, payload) {
    storeService.addPlayer(state, payload);
  },
  removePlayer: function (state, playerIndex) {
    storeService.removePlayer(state, playerIndex);
  },

  // five card hands section checkboxes
  setCheckedValueOfFiveCardHand: function (state, payload) {
    storeService.setCheckedValueOfFiveCardHand(state, {
      fiveCardHand: state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.find(payload.fiveCardHandId),
      newCheckedValue: payload.newCheckedValue,
    });

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      storeService.clearManuallySetHandsThatPassThroughFilter(state, {
        playerIndex: payload.playerIndex,
        playerStateIndex: payload.playerStateIndex,
        fiveCardHandId: payload.fiveCardHandId,
      });
    }
  },
  applyExactWeightToFiveCardHand: function (state, payload) {
    storeService.applyExactWeightToFiveCardHand(state, payload);
  },
  uncheckAllFiveCardHandsForGivenState: function (state, payload) {
    storeService.uncheckAllFiveCardHandsForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      storeService.clearManuallyAddedHands(state, payload);
      storeService.clearManuallyRemovedHands(state, payload);
    }
  },
  checkAllFiveCardHandsForGivenState: function (state, payload) {
    storeService.checkAllFiveCardHandsForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      storeService.clearManuallyAddedHands(state, payload);
      storeService.clearManuallyRemovedHands(state, payload);
    }
  },
  setChecksToDefaultsForGivenState: function (state, payload) {
    storeService.setChecksToDefaultsForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      storeService.clearManuallyAddedHands(state, payload);
      storeService.clearManuallyRemovedHands(state, payload);
    }
  },
  setChecksAccordingToUserDefinedFilterForGivenState: function (state, payload) {
    storeService.setChecksAccordingToUserDefinedFilterForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      storeService.clearManuallyAddedHands(state, payload);
      storeService.clearManuallyRemovedHands(state, payload);
    }
  },
  setFiveCardHandValuesToDefaults: function (state, payload) {
    storeService.setFiveCardHandValuesToDefaults(state, payload);
  },
  updateWeightOfFiveCardHand: function (state, payload) {
    storeService.updateWeightOfFiveCardHand(state, {
      fiveCardHand: state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.find(payload.fiveCardHandId),
      newWeight: payload.newWeight,
    });

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      storeService.clearManuallySetHandsThatPassThroughFilter(state, {
        playerIndex: payload.playerIndex,
        playerStateIndex: payload.playerStateIndex,
        fiveCardHandId: payload.fiveCardHandId,
      });
    }
  },

  // five card hands section other
  toggleCollapsedValueOfFiveCardHandParent: function (state, fiveCardHandParent) {
    storeService.toggleCollapsedValueOfFiveCardHandParent(state, fiveCardHandParent);
  },
  setProbabilitiesOfFiveCardHands: function (state, payload) {
    storeService.setProbabilitiesOfFiveCardHands(state, payload);
  },
  setHandAndDrawInfo: function (state, payload) {
    storeService.setHandAndDrawInfo(state, payload);
  },
  setHitPercentage: function (state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex]._hitPercentage = payload.hitPercentage;
  },
  setPercentagesOfSpecificHandsThatAreSelected: function (state, payload) {
    storeService.setPercentagesOfSpecificHandsThatAreSelected(state, payload);
  },

  // simulations
  setLastSimulationInfo: function (state, playerStateIndex) {
    storeService.setLastSimulationInfo(state, playerStateIndex);
  },
  setHitPercentageBeingComputed: function (state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].hitPercentageBeingComputed = payload.value;
  },
  updateEquityResults: function (state, payload) {
    let equity;
    let wins;
    let ties;
    let winFractions;
    let numberOfSimulations = payload.numberOfSimulations;
    let playerStateIndex = payload.playerStateIndex;

    state.players.forEach(function (player, playerIndex) {
      wins = payload.simulationResults[playerIndex + 1].wins;
      ties = payload.simulationResults[playerIndex + 1].ties;
      winFractions = payload.simulationResults[playerIndex + 1].winFractions; // equity that comes from ties; ex. with 3 players, when it's a three way tie you'll get 1/3 win fractions, and when it's a two way tie you'll get 1/2 win fractions

      equity = ((wins + winFractions) / numberOfSimulations) * 100;
      equity -= (equity * (payload.rakePercentage / 100)) + (equity * (payload.tipPercentage / 100));
      player.states[playerStateIndex].equity = equity.roundToTwoDecimalPlaces();
      player.states[playerStateIndex].winPercentage = (wins / numberOfSimulations) * 100;
      player.states[playerStateIndex].tiePercentage = (ties / numberOfSimulations) * 100;
    });
  },
  clearMatchingSpecificHands: function (state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.clearMatchingSpecificHands();
  },
};

let actions = {
  setHitPercentage: function (context, payload) { // doing this as an action rather than a mutation so that I could update the UI with "Computing hit percentage..."
    let hitPercentage;
    let hits = 0;
    let playerState = context.state.players.find(payload.playerIndex).states[payload.playerStateIndex];
    let weightOfLargestMatchingFiveCardHand;

    context.commit('setHitPercentageBeingComputed', {
      playerIndex: payload.playerIndex,
      playerStateIndex: payload.playerStateIndex,
      value: true,
    });
    setTimeout(function () { // using setTimeout so UI updates
      playerState.handAndDrawInfo.forEach(function ({ handInfo, drawInfo }) {
        weightOfLargestMatchingFiveCardHand = utilities.results.getWeightOfLargestMatchingFiveCardHand(
          handInfo,
          drawInfo,
          playerState.fiveCardHands.checkedHands
        );
        hits += weightOfLargestMatchingFiveCardHand / 100;
      });
      hitPercentage = ((hits / playerState.handAndDrawInfo.length) * 100).roundToTwoDecimalPlaces();
      context.commit('setHitPercentage', {
        playerIndex: payload.playerIndex,
        playerStateIndex: payload.playerStateIndex,
        hitPercentage: hitPercentage,
      });
      context.commit('setHitPercentageBeingComputed', {
        playerIndex: payload.playerIndex,
        playerStateIndex: payload.playerStateIndex,
        value: false,
      });
    }, 100);
  },
};

function _getSavedScenarios() {
  if (localStorage.getItem('hitCalculatorSavedScenarios')) {
    return JSON.parse(localStorage.getItem('hitCalculatorSavedScenarios'));
  }

  return [];
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/hit-calculator/hit-calculator.js